module.exports = __webpack_public_path__ + "static/media/whichThinnerLowerRisk.455656fb.mp3";